<base-modal-component (onConfirm)="save()" [validation]="isValid()" class="base-modal">
    <fields-list-component #fieldsListComponent [fields]="fields" [value]="hours"
                           name="testers_edit"></fields-list-component>
</base-modal-component>
